module.exports = __webpack_public_path__ + "static/30gde-199694baab8a931c3a990924ea163280.gif";